import { request } from "./shared/api";

document.body.classList.add('js');
document.body.classList.remove('no-js');

window.addEventListener('load', () => {
  const cams = document.querySelector('.cams-data');
  if (cams) {
    cams.addEventListener('click', async function (e) {
      const target = e.target as HTMLElement & { disabled: boolean };
      if (!target.classList.contains('remove-link')) return;
      const res = target.closest('.ressource');
      if (!res) return;
      e.preventDefault();
      target.disabled = true;
      target.innerText = '...';
      
      try {
        await request(target.dataset.url!, {
          method: 'DELETE',
        });
        res.remove();
      } catch (err: any) {
        console.error(err);
        alert(err.message || err);
      } finally {
        target.disabled = false;
        target.innerText = '(x)';
      }
    });
  }
  
  const entoggle = document.querySelector<HTMLButtonElement>('.enabled-toggle');
  const entext = document.querySelector('.enabled-status');
  if (entoggle && entext) entoggle.addEventListener('click', async function () {
    entoggle.disabled = true;
    const toenable = !entext.classList.contains('enabled');
    entext.classList.remove('enabled', 'disabled');

    try {
      const body = await request('/status', {
        method: 'PUT',
        body: toenable ? 'ON' : 'OFF',
      });
      if (Object.keys(body.errors).length) {
        alert('Fehler in Kamera(s)');
        console.error(body.errors);
      }
      entext.classList.add(toenable ? 'enabled' : 'disabled');
    } catch (err: any) {
      console.error(err);
      alert(err.message || err);
      entext.classList.add(!toenable ? 'enabled' : 'disabled');
    } finally {
      entoggle.disabled = false;
    }
  });
});
